import React from 'react';
import Badge from 'react-bootstrap/Badge';

function DatatableOrder(props) {
    const getStatusBadge = (status) => {
        const s = Number(status);
        switch (s) {
            case 1:
                return <Badge bg="primary">New Order</Badge>;
            case 2:
                return <Badge bg="info">Accepted</Badge>;
            case 3:
                return <Badge bg="warning" text="dark">Dispatched</Badge>;
            case 4:
                return <Badge bg="secondary">Out For Delivery</Badge>;
            case 5:
                return <Badge bg="success">Delivered</Badge>;
            case 6:
                return <Badge bg="danger">Cancelled (User)</Badge>;
            case 7:
                return <Badge bg="danger">Cancelled (Admin)</Badge>;
            case 8:
                return <Badge bg="dark">Rejected</Badge>;
            default:
                return <Badge bg="secondary">Pending</Badge>;
        }
    };

    return (
        <div className="table-responsive">
            <table className='table table-bordered table-hover mb-0'>
                <thead>
                    <tr>
                        <th style={{ width: '75px' }}>Order ID</th>
                        <th>Buyer's Name</th>
                        <th>Amount</th>
                        <th>Payment</th>
                        <th>Order Date</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {props.orderList && props.orderList.length > 0 ? (
                        props.orderList.map((item, index) => {
                            const orderStatus = item.order_status !== undefined ? item.order_status : item.status;
                            const amount = Number(item.overall_price || item.total_price || 0);
                            return (
                                <tr key={item.id || index}>
                                    <td><strong>#{item.id}</strong></td>
                                    <td>
                                        <div className="fw-bold">{item.user_name || 'Customer'}</div>
                                        {item.user_phone && (
                                            <small className="text-muted">{item.user_phone}</small>
                                        )}
                                    </td>
                                    <td>
                                        <strong className="text-success">
                                            ₹{amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </strong>
                                    </td>
                                    <td>
                                        <span className={`badge ${item.payment_type === 'Online' ? 'bg-primary' : 'bg-secondary'}`}>
                                            {item.payment_type || 'COD'}
                                        </span>
                                    </td>
                                    <td>{item.order_date || 'N/A'}</td>
                                    <td>{getStatusBadge(orderStatus)}</td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="6" className="text-center py-3 text-muted">No orders found</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default DatatableOrder;
